import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { ApplicationEntryLayout } from '../components/ApplicationEntryLayout/ApplicationEntryLayout';
import ValidationGroup from 'devextreme-react/validation-group';
import { useValidateAndSaveApplication } from '../hooks/useValidateAndSaveApplication';
import { OtherAmount as LandCostOtherAmount } from './components/LandCost/components/OtherAmount';
import { OtherDescription as LandCostOtherDescription } from './components/LandCost/components/OtherDescription';
import { OtherAmount as SiteWorkOtherAmount } from './components/SiteWork/components/OtherAmount';
import { OtherDescription as SiteWorkOtherDescription } from './components/SiteWork/components/OtherDescription';
import { OtherAmount as FoundationsOtherAmount } from './components/Foundations/components/OtherAmount';
import { OtherDescription as FoundationsOtherDescription } from './components/Foundations/components/OtherDescription';
import { OtherAmount as FramingOtherAmount } from './components/Framing/components/OtherAmount';
import { OtherDescription as FramingOtherDescription } from './components/Framing/components/OtherDescription';
import { OtherAmount as ExteriorFinishesOtherAmount } from './components/ExteriorFinishes/components/OtherAmount';
import { OtherDescription as ExteriorFinishesOtherDescription } from './components/ExteriorFinishes/components/OtherDescription';
import { OtherAmount as MajorSystemRoughInsOtherAmount } from './components/MajorSystemRoughIns/components/OtherAmount';
import { OtherDescription as MajorSystemRoughInsOtherDescription } from './components/MajorSystemRoughIns/components/OtherDescription';
import { OtherAmount as InteriorFinishesOtherAmount } from './components/InteriorFinishes/components/OtherAmount';
import { OtherDescription as InteriorFinishesOtherDescription } from './components/InteriorFinishes/components/OtherDescription';
import { OtherAmount as FinalStepsOtherAmount } from './components/FinalSteps/components/OtherAmount';
import { OtherDescription as FinalStepsOtherDescription } from './components/FinalSteps/components/OtherDescription';
import { Name as FoundationsLargestSupplierName } from './components/FoundationsLargestSupplier/components/Name';
import { Phone as FoundationsLargestSupplierPhone } from './components/FoundationsLargestSupplier/components/Phone';
import { Name as FramingLargestSupplierName } from './components/FramingLargestSupplier/components/Name';
import { Phone as FramingLargestSupplierPhone } from './components/FramingLargestSupplier/components/Phone';
import { Name as ElectricalLargestSupplierName } from './components/ElectricalLargestSupplier/components/Name';
import { Phone as ElectricalLargestSupplierPhone } from './components/ElectricalLargestSupplier/components/Phone';
import { Name as HVACLargestSupplierName } from './components/HVACLargestSupplier/components/Name';
import { Phone as HVACLargestSupplierPhone } from './components/HVACLargestSupplier/components/Phone';
import { Name as PlumbingLargestSupplierName } from './components/PlumbingLargestSupplier/components/Name';
import { Phone as PlumbingLargestSupplierPhone } from './components/PlumbingLargestSupplier/components/Phone';
import { LandCost } from './components/LandCost/components/LandCost';
import { Demolition } from './components/SiteWork/components/Demolition';
import { BuildingPermitFees } from './components/SiteWork/components/BuildingPermitFees';
import { Utilities } from './components/SiteWork/components/Utilities';
import { Inspections } from './components/SiteWork/components/Inspections';
import { ArchitectureEngineering } from './components/SiteWork/components/ArchitectureEngineering';
import { ClearingGrading } from './components/SiteWork/components/ClearingGrading';
import { WellWater } from './components/SiteWork/components/WellWater';
import { SepticSewer } from './components/SiteWork/components/SepticSewer';
import { ExcavationsBackfill } from './components/Foundations/components/ExcavationsBackfill';
import { RetainingWalls } from './components/Foundations/components/RetainingWalls';
import { FootingsFoundationConcrete } from './components/Foundations/components/FootingsFoundationConcrete';
import { Slabs } from './components/Foundations/components/Slabs';
import { Framing } from './components/Framing/components/Framing';
import { Trusses } from './components/Framing/components/Trusses';
import { Sheathing } from './components/Framing/components/Sheathing';
import { GeneralMetal } from './components/Framing/components/GeneralMetal';
import { ExteriorWallFinish } from './components/ExteriorFinishes/components/ExteriorWallFinish';
import { Roofing } from './components/ExteriorFinishes/components/Roofing';
import { WindowsAndDoors } from './components/ExteriorFinishes/components/WindowsAndDoors';
import { GarageDoor } from './components/ExteriorFinishes/components/GarageDoor';
import { Plumbing } from './components/MajorSystemRoughIns/components/Plumbing';
import { Electrical } from './components/MajorSystemRoughIns/components/Electrical';
import { HVAC } from './components/MajorSystemRoughIns/components/HVAC';
import { Insulation } from './components/InteriorFinishes/components/Insulation';
import { Drywall } from './components/InteriorFinishes/components/Drywall';
import { InteriorTrimsDoorsMirrors } from './components/InteriorFinishes/components/InteriorTrimsDoorsMirrors';
import { Painting } from './components/InteriorFinishes/components/Painting';
import { Lighting } from './components/InteriorFinishes/components/Lighting';
import { CabinetsCountertops } from './components/InteriorFinishes/components/CabinetsCountertops';
import { Appliances } from './components/InteriorFinishes/components/Appliances';
import { PlumbingFixtures } from './components/InteriorFinishes/components/PlumbingFixtures';
import { Flooring } from './components/InteriorFinishes/components/Flooring';
import { Fireplaces } from './components/InteriorFinishes/components/Fireplaces';
import { Landscaping } from './components/FinalSteps/components/Landscaping';
import { OutdoorStructures } from './components/FinalSteps/components/OutdoorStructures';
import { DrivewayAndWalks } from './components/FinalSteps/components/DrivewayAndWalks';
import { CleanUp } from './components/FinalSteps/components/CleanUp';
import { Button, ButtonTheme, useWaitOverlayStore } from '@apply/components';
import { ApplyApi, IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { applicationInsights } from '../../ApplicationInsights';
import '../scss/_budgetPage.scss';
import Validator, { CustomRule } from 'devextreme-react/validator';
import DxTextBox from 'devextreme-react/text-box';
import ValidationSummary from 'devextreme-react/validation-summary';
import validationEngine from 'devextreme/ui/validation_engine';
import { useSaveApplicationWithoutValidation } from '../hooks/useSaveApplicationWithoutValidation';
import { useRedirectIfComplete } from '../hooks/useRedirectIfApplicationComplete';
import { CurrentApplicationPage, useNavigateApplication } from '../hooks/useNavigateApplication';
import { budgetAndSpecSheetNameBuilder } from '../constants/budgetAndSpecSheetNameBuilder';
import { usePausePointTracker } from '../hooks/usePausePointTracker.tsx';
import { sumBudgetNumbers } from './functions/sumBudgetNumbers.ts';
import { BudgetTotal } from './components/BudgetTotal.tsx';
import { useApplicationQuery } from '../../queries/applicationQueries';
import { useApplicationPropertyForms } from '../../queries/BorrowerFields/ApplicationFields';
import { usePropertyStreet1, usePropertyStreet2 } from '../../queries/usePropertyCoreFields';
import { usePropertyBudgetFile } from '../../queries/PropertyFileFields/NonRentalFiles';
import { useBudgetConstructionCache } from './queries/useBudgetConstructionCache';
import { ApplicationCrumbType } from '../components/ApplicationEntryLayout/components/ApplicationEntrySections/types/ApplicationCrumbType.tsx';

interface BudgetPageParameters {
    printMode?: boolean;
}

export const BudgetPage: React.FC<BudgetPageParameters> = ({ printMode = false }) => {
    const { entryGuid } = useParams<{ entryGuid?: string }>();
    const { search } = useLocation();
    const propertyGuid = new URLSearchParams(search).get('pid') || '';

    const token = new URLSearchParams(search).get('token');
    const { isPending } = useApplicationQuery(entryGuid, token);

    const applyApi = new ApplyApi(applicationInsights);
    const BUDGET_GROUP = 'budget-min-total';
    const validationGroupRef = useRef(null);
    const { validateAndSaveApplication } = useValidateAndSaveApplication(validationGroupRef);
    const { saveApplicationNoValidation } = useSaveApplicationWithoutValidation();
    const navigate = useNavigate();
    const budget = useBudgetConstructionCache(propertyGuid);
    const { handleMode: budgetHandleMode, setSavedFormId } = usePropertyBudgetFile(propertyGuid);
    const [propertyName] = usePropertyStreet1(propertyGuid);
    const [propertyName2] = usePropertyStreet2(propertyGuid);
    const [forms, setForms] = useApplicationPropertyForms();
    const { navigateApplicationForward, navigateApplicationBackward } = useNavigateApplication({
        page: CurrentApplicationPage.Budget,
        entryGuid,
        propertyGuid,
    });
    const { updatePausePoint, clearPausePoint } = usePausePointTracker();

    const newBudgetSelected = budgetHandleMode === 'createnewform';
    const savedBudgetSelected = budgetHandleMode === 'editsavedform';

    useRedirectIfComplete(printMode);

    useEffect(() => {
        if (!isPending) {
            useWaitOverlayStore.getState().setWaiting(false);
        }
    }, [isPending]);

    // Create a form stub in the cache when creating a new budget (not loading a saved one)
    useEffect(() => {
        if (!entryGuid || savedBudgetSelected) return;
        const currentForms = forms ?? [];
        const exists = currentForms.some((f) => f.type === 'Budget' && f.propertyGuid === propertyGuid);
        if (exists) return;
        const stub: IBudgetConstruction = {
            id: 0,
            guid: entryGuid,
            type: 'Budget' as IBudgetConstruction['type'],
            name: '',
            propertyGuid,
            values: {} as IBudgetConstruction['values'],
        };
        setForms([...currentForms, stub]);
    }, [entryGuid, savedBudgetSelected]);

    // Keep form name in sync with property address
    useEffect(() => {
        if (!entryGuid) return;
        const currentForms = forms ?? [];
        const fullPN = budgetAndSpecSheetNameBuilder(propertyName ?? '', propertyName2 ?? '');
        const idx = currentForms.findIndex((f) => f.type === 'Budget' && f.propertyGuid === propertyGuid);
        if (idx === -1) return;
        const newForms = [...currentForms];
        newForms[idx] = { ...newForms[idx], name: fullPN };
        setForms(newForms);
    }, [propertyName, propertyName2]);

    useEffect(() => {
        if (printMode) document.body.style.backgroundColor = '#fff';
    }, [printMode]);

    if (isPending && entryGuid) {
        return null;
    }

    const onSaveAndContinue = async (e: React.MouseEvent<Element, MouseEvent>) => {
        if (e) e.preventDefault();

        const result = validationEngine.validateGroup(BUDGET_GROUP);
        if (!result?.isValid) return;

        clearPausePoint();

        const applicationResponse = await validateAndSaveApplication();
        if (!applicationResponse) return;

        const savedFormResponse = await applyApi.updateSharedForm(budget!);
        if (savedFormResponse?.result) setSavedFormId(savedFormResponse.result);

        navigateApplicationForward();
    };

    const onSaveAndExit = async (e: React.MouseEvent<Element, MouseEvent>) => {
        if (e) e.preventDefault();

        updatePausePoint();

        const applicationResponse = await saveApplicationNoValidation();
        if (!applicationResponse) return;

        const savedFormResponse = await applyApi.updateSharedForm(budget!);
        if (savedFormResponse?.result) setSavedFormId(savedFormResponse.result);

        navigate('/home');
    };

    const onChangeAutofill = async () => {
        await validateAndSaveApplication();
        navigate(`/budget/selectbudget/${entryGuid}?pid=${propertyGuid}`);
    };

    const nextStepButton = {
        id: 'continueApplicationButton',
        dataTestid: 'continueApplicationButton',
        children: 'Continue',
        handleClick: onSaveAndContinue,
    };

    const saveAndExitButton = {
        id: 'saveAndExitApplicationButton',
        dataTestid: 'saveAndExitApplicationButton',
        children: 'Save and Exit',
        handleClick: onSaveAndExit,
    };

    const previousStepButtonClick = async (e: React.MouseEvent<Element, MouseEvent>) => {
        if (e) e.preventDefault();

        clearPausePoint();

        const applicationResponse = await saveApplicationNoValidation();
        if (!applicationResponse) return;

        navigateApplicationBackward();
    };

    return (
        <ValidationGroup
            ref={validationGroupRef}
            className={printMode ? 'print' : ''}
        >
            <ApplicationEntryLayout
                currentCrumb={ApplicationCrumbType.Budget}
                saveAndExitButtonProps={saveAndExitButton}
                nextStepButtonProps={nextStepButton}
                previousStepButtonVisible={true}
                previousStepButtonClick={previousStepButtonClick}
                propertyAddress={propertyName}
                printMode={printMode}
            >
                <div>
                    {' '}
                    {!printMode && !newBudgetSelected ? (
                        <Button
                            id='tertiaryBudgetButton'
                            theme={ButtonTheme.TertiaryBudget}
                            handleClick={onChangeAutofill}
                            children={
                                <div className='autofill'>
                                    Change autofill selection
                                    <img
                                        src='/assets/img/change-autofill.png'
                                        alt='Change Autofill Selection'
                                        height='100%'
                                    />
                                </div>
                            }
                        ></Button>
                    ) : (
                        <h1>Budget</h1>
                    )}
                    <div>
                        <h4 className='headers'>Land Cost</h4>
                        <LandCost
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <span className='paired-fields'>
                            <LandCostOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <LandCostOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div>
                        <h4 className='headers'>Site Work</h4>
                        <Demolition
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <BuildingPermitFees
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Utilities
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Inspections
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <ArchitectureEngineering
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <ClearingGrading
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <WellWater
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <SepticSewer
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <span className='paired-fields'>
                            <SiteWorkOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <SiteWorkOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div>
                        <h4 className='headers'>Foundations</h4>
                        <ExcavationsBackfill
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <RetainingWalls
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <FootingsFoundationConcrete
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Slabs
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <span className='paired-fields'>
                            <FoundationsOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <FoundationsOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div>
                        <h4 className='headers'>Foundations (Largest Subcontractor or Supplier)</h4>
                        <FoundationsLargestSupplierName
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <FoundationsLargestSupplierPhone
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                    </div>
                    <div>
                        <h4 className='headers'>Framing</h4>
                        <Framing
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Trusses
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Sheathing
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <GeneralMetal
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <span className='paired-fields'>
                            <FramingOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <FramingOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div>
                        <h4 className='headers'>Framing (Largest Subcontractor or Supplier)</h4>
                        <FramingLargestSupplierName
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <FramingLargestSupplierPhone
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                    </div>
                    <div>
                        <h4 className='headers'>Exterior Finishes</h4>
                        <ExteriorWallFinish
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Roofing
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <WindowsAndDoors
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <GarageDoor
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <span className='paired-fields'>
                            <ExteriorFinishesOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <ExteriorFinishesOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div>
                        <h4 className='headers'>Major Systems Rough-ins</h4>
                        <Plumbing
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Electrical
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <HVAC
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <span className='paired-fields'>
                            <MajorSystemRoughInsOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <MajorSystemRoughInsOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div>
                        <h4 className='headers'>Electrical (Largest Subcontractor or Supplier)</h4>
                        <ElectricalLargestSupplierName
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <ElectricalLargestSupplierPhone
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                    </div>
                    <div>
                        <h4 className='headers'>HVAC (Largest Subcontractor or Supplier)</h4>
                        <HVACLargestSupplierName
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <HVACLargestSupplierPhone
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                    </div>
                    <div>
                        <h4 className='headers'>Plumbing (Largest Subcontractor or Supplier)</h4>
                        <PlumbingLargestSupplierName
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <PlumbingLargestSupplierPhone
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                    </div>
                    <div>
                        <h4 className='headers'>Interior Finishes</h4>
                        <Insulation
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Drywall
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <InteriorTrimsDoorsMirrors
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Painting
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Lighting
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <CabinetsCountertops
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Appliances
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Flooring
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <PlumbingFixtures
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <Fireplaces
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <span className='paired-fields'>
                            <InteriorFinishesOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <InteriorFinishesOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <div>
                        <h4 className='headers'>Final Steps</h4>
                        <Landscaping
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <OutdoorStructures
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <DrivewayAndWalks
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <CleanUp
                            propertyGuid={propertyGuid}
                            isReview={printMode}
                        />
                        <span className='paired-fields'>
                            <FinalStepsOtherDescription
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                            <FinalStepsOtherAmount
                                propertyGuid={propertyGuid}
                                isReview={printMode}
                            />
                        </span>
                    </div>
                    <BudgetTotal budget={budget!} />
                </div>
                <DxTextBox
                    value=''
                    visible={false}
                >
                    <Validator validationGroup={BUDGET_GROUP}>
                        <CustomRule
                            reevaluate={true}
                            message='Total budget value too low, minimum total budget is $75,000'
                            validationCallback={() => sumBudgetNumbers(budget?.values ?? {}) >= 75000}
                        />
                    </Validator>
                </DxTextBox>
                <div className='validation-summary-center'>
                    <ValidationSummary validationGroup={BUDGET_GROUP} />
                </div>
            </ApplicationEntryLayout>
        </ValidationGroup>
    );
};
